import { callGraphQLEndpoint } from '../index'

const getLegalDocumentsListQuery = (
  authToken,
  { cityId, includeInactive = true } = {},
) => {
  const query = `
    query ($countryId:ID $includeInactive: Boolean) {
      legalDocuments(countryId:$countryId includeInactive:$includeInactive) {
        edges {
          node {
            id
            name
            url
            countryId
            active
            createdAt
            userRole
          }
        }
        totalCount
      }
    }
    `
  return callGraphQLEndpoint(authToken, query, { cityId, includeInactive })
}

const getLegalDocumentByIdQuery = (authToken, { id }) => {
  const query = `
    query ($id:ID!) {
      legalDocument(id:$id) {
        id
        name
        url
        countryId
        active
        userRole
        createdAt
      }
    }
    `
  return callGraphQLEndpoint(authToken, query, { id })
}

const createLegalDocumentMutation = (
  authToken,
  { countryId, name, url, userRole },
) => {
  const query = `
    mutation ($input:CreateLegalDocumentInput) {
      createLegalDocument(input:$input){
        legalDocument {
          id
          name
          url
          countryId
          userRole
        }
      }
    }
    `
  return callGraphQLEndpoint(authToken, query, {
    input: { countryId, name, url, userRole },
  })
}

const updateLegalDocumentByIdMutation = (authToken, { id, countryId }) => {
  const query = `
    mutation ($input:UpdateLegalDocumentInput) {
      updateLegalDocument(input:$input){
        legalDocument {
          id
          name
          url
          countryId
          userRole
        }
      }
    }
    `
  return callGraphQLEndpoint(authToken, query, { input: { id, countryId } })
}

const deleteLegalDocumentByIdMutation = (authToken, { id }) => {
  const query = `
    mutation ($input:DeleteLegalDocumentInput) {
      deleteLegalDocument(input:$input)
    }
    `
  return callGraphQLEndpoint(authToken, query, { input: { id } })
}

export {
  getLegalDocumentsListQuery,
  getLegalDocumentByIdQuery,
  createLegalDocumentMutation,
  updateLegalDocumentByIdMutation,
  deleteLegalDocumentByIdMutation,
}



// WEBPACK FOOTER //
// ./src/Module/graphQL/LegalDocument/legalDocumentGraphQL.js